import React from 'react';
export function Footer() {
  return <footer className="w-full bg-plum-deep" data-id="element-92" data-mp="32wd2qgad7ltj">
      <div className="max-w-3xl mx-auto px-5 py-12 text-center" data-id="element-93" data-mp="3gezeh7brdx2q">
        <h3 className="font-display text-2xl font-semibold text-gold" data-id="element-94" data-mp="3ghc2o28413o8">
          52 Weeks of <span className="italic" data-id="element-95" data-mp="32pfc42m3b1ty">Barre</span>
        </h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-white/70" data-id="element-96" data-mp="36oxwmxa01aw9">
          The 52-Week Barre Map — because teaching barre shouldn&apos;t cost you
          every evening of the week.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2.5 text-[13px] text-white/70" data-id="element-97" data-mp="398y6cw8527j">
          <a href="mailto:help@iclcollective.com" className="hover:text-white hover:underline" data-id="element-98" data-mp="3lf56iolxxllc">
            help@iclcollective.com
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-plum-line pt-5 text-xs leading-relaxed text-white/45" data-id="element-99" data-mp="29yxehh44xsnx">
          52 Weeks of Barre is an educational resource for fitness instructors.
          It does not replace instructor certification, CPR/first-aid training
          or the policies of your studio, gym or facility. Suggested
          modifications stay within the scope of a fitness instructor; clients
          with injuries, pregnancy or postpartum questions should consult a
          health professional. Not affiliated with any barre studio brand or
          method. No specific physical results are promised. © 52 Weeks of Barre
          2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}